import { render, staticRenderFns } from "./default-bar.md?vue&type=template&id=6592225b&"
import script from "./default-bar.md?vue&type=script&lang=js&"
export * from "./default-bar.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6592225b')) {
      api.createRecord('6592225b', component.options)
    } else {
      api.reload('6592225b', component.options)
    }
    module.hot.accept("./default-bar.md?vue&type=template&id=6592225b&", function () {
      api.rerender('6592225b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/demo/Bar/default-bar.md"
export default component.exports